<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="nonindent"><span class="big2"><strong>She felt his fingers release the clip holding her hair, and as it fell about her shoulders Cherry jerked away.</strong></span></p>
<p class="extract">‘Don’t,’ she said sharply, holding out her hand for the fastener. ‘It’s too hot to wear it down today.’</p>
<p class="extract">‘And is this the only reason you hide such beauty from me?’ he said, ignoring her outstretched fingers.</p>
<p class="extract">She stared at him, wondering if he was making fun of her. Her hair was ordinary. She was ordinary.</p>
<p class="extract">‘My hair is nothing special.’ She fixed him with her most severe look. ‘And how I choose to wear it has absolutely nothing to do with you.’</p>
<p class="extract">He smiled faintly, which Cherry found incredibly irritating. ‘Do not deny once again there is not a man behind your sojourn in my country,’ he said with unforgivable audacity. ‘A man who is stupid enough to let you slip through his fingers does not deserve you anyway.’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781460346471_epub_exc_r1.vue?4bbd7ba4